import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/useAuthStore';
import { useChatStore } from '../stores/useChatStore';
import SessionSidebar from '../components/chat/SessionSidebar';
import ChatWindow from '../components/chat/ChatWindow';
import ChatInput from '../components/chat/ChatInput';
import ModelSelector from '../components/chat/ModelSelector';
import UsageBadge from '../components/chat/UsageBadge';
import './ChatPage.css';

export default function ChatPage() {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();
  const {
    sessions,
    currentSessionId,
    loadModels,
    loadSessions,
    loadUsage,
    defaultModel,
    createSession,
    selectSession
  } = useChatStore();

  useEffect(() => {
    loadModels();
    loadSessions();
    loadUsage();
  }, [loadModels, loadSessions, loadUsage]);

  if (!user) return <Navigate to="/login" replace />;

  const currentSession = sessions.find((s) => s._id === currentSessionId) || null;

  async function handleNewSession() {
    const sess = await createSession(defaultModel);
    await selectSession(sess._id);
  }

  return (
    <div className="chat-page">
      <SessionSidebar onNewSession={handleNewSession} />
      <main className="chat-main">
        <header className="chat-header">
          <div className="chat-header-left">
            {currentSession ? (
              <>
                <h2 className="chat-title">{currentSession.title}</h2>
                <ModelSelector />
              </>
            ) : (
              <h2 className="chat-title">Wähle eine Session oder starte eine neue.</h2>
            )}
          </div>
          <div className="chat-header-right">
            <UsageBadge />
            <span className="chat-user">{user.email}</span>
            <button
              className="chat-logout"
              onClick={() => {
                logout();
                navigate('/login');
              }}
            >
              Logout
            </button>
          </div>
        </header>
        <ChatWindow />
        {currentSession && <ChatInput />}
      </main>
    </div>
  );
}
